import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import './text-box.scss';
import { getNumberWithDot } from '../../helpers/utils';
import { InfoIcon } from '../icons/icons';

const TextBox = forwardRef(
  (
    {
      id,
      label,
      errorMessage,
      required,
      message,
      mBottom,
      size,
      width,
      className,
      type,
      maxLength,
      bMargin,
      infoMessage,
      infoMessageColour,
      textboxClassName,
      onFocus,
      onBlur,
      classNameTextboxGroup,
      ...otherProps
    },
    ref
  ) => {
    return (
      <div
        className={`text-box-group ${className}`}
        style={{ marginBottom: mBottom, width }}
      >
        {label && (
          <label htmlFor={id} data-cy="text-box-label">
            {label}
            {required && <span className="required">*</span>}
          </label>
        )}
        <div
          className={`textbox-group ${classNameTextboxGroup}`}
          data-cy="text-box-input-block"
        >
          <input
            id={id}
            type={type}
            ref={ref}
            onKeyDown={(e) => {
              if (id === 'totalPrice' || id === 'pricePerUnit') {
                getNumberWithDot({ e, decimalLimit: 4 });
              }
            }}
            {...(type === 'number' && {
              onWheelCapture: (e) => {
                e.target.blur();
              },
            })}
            {...otherProps}
            style={{ fontSize: size }}
            maxLength={maxLength}
            className={textboxClassName}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          {infoMessage !== '' ? (
            <span className="info-icon">
              <InfoIcon color={infoMessageColour} />
              <span className="info-message">{infoMessage}</span>
            </span>
          ) : null}
        </div>
        {message !== '' && (
          <p className="message" style={{ marginBottom: bMargin }}>
            {message}
          </p>
        )}
        {errorMessage && errorMessage !== '' && (
          <p className="error-message" style={{ marginBottom: bMargin }}>
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);

TextBox.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  message: PropTypes.string,
  mBottom: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  bMargin: PropTypes.string,
  infoMessage: PropTypes.string,
  infoMessageColour: PropTypes.string,
  textboxClassName: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  classNameTextboxGroup: PropTypes.string,
};

TextBox.defaultProps = {
  label: '',
  id: '',
  errorMessage: '',
  required: false,
  message: '',
  mBottom: '',
  size: '',
  width: '',
  className: '',
  type: 'text',
  maxLength: 50,
  bMargin: '',
  infoMessage: '',
  infoMessageColour: '',
  textboxClassName: '',
  onFocus: () => {},
  onBlur: () => {},
  classNameTextboxGroup: '',
};

export default memo(TextBox);
